import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "src/store/actions/action";
import { useDispatch } from "react-redux";
import { setMinusLimitImage, setNoticeRegister, setPlusLimitImage } from "src/store/reducers/noticeReduce";
import moment from "moment";
import Calendar from "react-calendar";
import ReadOnlySwitch from "../common/ReadOnlySwitch";
import Box from "../common/Box";
import BottomModal, { RefProps } from "../common/BottomModal";
import styled from "styled-components";
import cn from "classnames";
import icoStyledLink from "src/assets/images/icoStyledLink.svg";
import SwitchV2 from "../common/SwitchV2";
import IcoDateBlue from "src/assets/images/icoDateBlue.svg";
import Button from "../common/Button";

const WriteOptionItem = () => {
  const noticeData = useAppSelector((state) => state.noticeReduce);
  const dispatch = useDispatch();
  const calendarRef = React.useRef<RefProps>(null);
  const [date, setDate] = useState(new Date());

  function openCalendar() {
    if (noticeData.dateToggle) {
      dispatch(setNoticeRegister({ dateToggle: false, endDate: "" }));
      setDate(new Date());
    } else {
      const tempDate = new Date();
      tempDate.setDate(date.getDate() + 7);
      const dateFormat = moment(tempDate).format("YYYY.MM.DD");
      dispatch(setNoticeRegister({ dateToggle: true, endDate: dateFormat }));
      setDate(tempDate);
    }
  }

  const CaleanderOnClick = (e: any) => {
    if (calendarRef.current) calendarRef.current.modalClose();
    const now = moment();
    if (moment(e).isAfter(now)) {
      document.body.style.overflow = "unset";
      const dateFormat = moment(e).format("YYYY.MM.DD");
      dispatch(setNoticeRegister({ dateToggle: true, endDate: dateFormat }));
    } else {
      alert("이미 지난 날짜는 선택할 수 없습니다.");
    }
  };

  return (
    <>
      <li>
        <StyledLink to="/fulfill-select" state={true}>
          <OptionBox>
            <div className="title">이행매장</div>
            <div>
              <span className="info-num active">{noticeData.stores?.length == 0 ? "" : noticeData.stores?.length + "개점"}</span>
            </div>
          </OptionBox>
        </StyledLink>
      </li>
      <li>
        <OptionBox>
          <div className="title">
            마감일자
            {noticeData.endDate ? (
              <span className={cn("info-date", { active: noticeData.endDate })} onClick={() => calendarRef.current?.modalOpen()}>
                {noticeData.endDate}
              </span>
            ) : (
              <span className="info-mes">이행매장이 있는 경우 마감일자 등록은 필수입니다.</span>
            )}
          </div>
          <div>
            <ReadOnlySwitch checked={noticeData.dateToggle} onChange={() => openCalendar()} />
          </div>
        </OptionBox>
      </li>
      <li>
        <OptionBox>
          <div className="title">
            중요공지
            <span className="info-mes">최대 5개까지 설정 가능하며, 목록 상단에 고정됩니다.</span>
          </div>
          <div>
            <SwitchV2
              id="write-setting02"
              checked={noticeData.importNotice}
              onChange={() => dispatch(setNoticeRegister({ importNotice: !noticeData.importNotice }))}
            />
          </div>
        </OptionBox>
      </li>
      <li>
        <OptionBox style={{ alignItems: "center" }}>
          <div className="title">
            최소 사진 개수 설정
            <span className="info-mes">매장이 업로드해야 하는 최소 사진 개수를 설정해 주세요.</span>
          </div>
          <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
            <Button onClick={() => dispatch(setMinusLimitImage())}>-</Button>
            <div style={{ fontSize: "1.5rem", fontWeight: "600" }}>{noticeData.limitImage}</div>
            <Button onClick={() => dispatch(setPlusLimitImage())}>+</Button>
          </div>
        </OptionBox>
      </li>

      <BottomModal ref={calendarRef} modalTitle="마감일 지정">
        <Box pd="15px">
          <Calendar
            onChange={setDate}
            minDetail="decade"
            formatMonthYear={(locale, date) => moment(date).format("YYYY. MM")}
            formatDay={(locale, date) => moment(date).format("D")} // 날 표시할때 '일', 0 제외하고 숫자만 보이도록 설정
            value={date}
            showNeighboringMonth={false} //  전달, 다음달 날짜 표시 안함
            calendarType="US" // 주의 첫번째 요일 일요일부터 시작
            onClickDay={(e) => CaleanderOnClick(e)}
          />
        </Box>
      </BottomModal>
    </>
  );
};

const OptionBox = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("row", "space-between", "flex-start")}

  .title {
    font-weight: 400;
    line-height: 20px;
    margin-top: 4px;
    > .info-date {
      display: none;
      padding: 5px 35px 5px 59px;
      margin-top: 10px;
      border: 1px solid ${({ theme }) => theme.color.subMain};
      border-radius: 4px;
      background: url(${IcoDateBlue}) no-repeat left center;
      background-position-x: 31px;
      background-color: rgba(20, 110, 170, 0.1);
      color: ${({ theme }) => theme.color.subMain};
      font-family: "Poppins";
      font-size: 14px;
      &.active {
        display: block;
      }
    }
    > .info-mes {
      display: block;
      margin-top: 10px;
      color: ${({ theme }) => theme.color.lineSecondary};
      font-size: 12px;
    }
  }
  .info-num {
    display: none;
    font-size: 16px;
    line-height: 20px;
    &.active {
      display: block;
      color: ${({ theme }) => theme.color.subMain};
      font-weight: 700;
    }
  }
`;

const StyledLink = styled(Link)`
  display: block;
  padding-right: 20px;
  font-weight: 400;
  line-height: 20px;
  background: url(${icoStyledLink}) no-repeat right center;
  background-position-y: 1px;
  .title {
    margin-top: 0;
  }
`;

export default WriteOptionItem;
